import firestore from "./firebase";
import { addDoc, collection } from "firebase/firestore"; 

const logPlay = async (user, checkpoint, star) => {    

    const logger = {
        ...user,
        checkpoint,
        star,
        date: new Date().toString(),
    }

    const logs =  await addDoc(collection(firestore, "logs"), logger);    
    return logs.id;
}

export default logPlay;